import { Toaster } from 'react-hot-toast';
import { Routes, Route } from 'react-router';
import DataPrivacyRoute from './DataPrivacyRoute';
import DataAgreementRoute from './DataAgreementRoute';
import LegalNoteRoute from './LegalNoteRoute';
import TermsOfUseRoute from './TermsOfUseRoute';
import RevokeRoute from './RevokeRoute';
import RevokeSuccessRoute from './RevokeSuccessRoute';
import { useTranslation } from 'react-i18next';
import { LatestDataPrivacyRoute } from './LatestDataPrivacyRoute';

export function App() {
  const { t } = useTranslation('data_privacy');
  return (
    <div className="w-full h-full flex items-center flex-col text-[#454545]">
      <Toaster position="bottom-right" />

      <div id="header" className="w-full bg-[#373d40] min-h-16 flex justify-center">
        <div className="w-full max-w-2xl flex items-center px-4">
          <img src="/termios-logo-white.svg" alt="termios" className="max-h-4" />
        </div>
      </div>

      <Routes>
        <Route path="/" element={<LatestDataPrivacyRoute />} />
        <Route path="/data-privacy/:embedded?/:language?" element={<DataPrivacyRoute />} />
        <Route path="/data-agreement/:embedded?/:language?" element={<DataAgreementRoute />} />
        <Route path="/legal-note/:embedded?/:language?" element={<LegalNoteRoute />} />
        <Route path="/terms-of-use/:embedded?/:language?" element={<TermsOfUseRoute />} />
        <Route path="/data-privacy-revocation/:token" element={<RevokeRoute />} />
        <Route path="/data-privacy-revocation-success" element={<RevokeSuccessRoute />} />
      </Routes>

      {/* FOOTER */}
      <div id="footer" className="w-full bg-[#373d40] min-h-16 flex justify-center mt-auto text-xs">
        <div className="w-full max-w-2xl flex items-center px-4 text-white">
          <div className="mr-16">&copy; 2024 | termios</div>
          <ul className="flex flex-row">
            <li className="mr-8 hover:underline">
              <a href="https://www.termios.de/kontakt" target="_blank" rel="noreferrer" className="capitalize">
                {t('navigation.contact')}
              </a>
            </li>
            <li className="mr-8 hover:underline">
              <a href="https://www.termios.de/impressum" target="_blank" rel="noreferrer">
                {t('navigation.imprint')}
              </a>
            </li>
            <li className="mr-8 hover:underline">
              <a href="https://www.termios.de/datenschutz" target="_blank" rel="noreferrer">
                {t('navigation.data_protection')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default App;
